(function() {
  'use strict';

  var variantsEl = document.getElementById('productVariantsJson');
  if (!variantsEl) return;

  var variants = JSON.parse(variantsEl.textContent);
  var currentOptions = {};

  var colorOptionIndex = -1;
  var swatchContainers = document.querySelectorAll('.color-swatches');
  if (swatchContainers.length > 0) {
    var firstSwatch = swatchContainers[0].querySelector('.color-swatch');
    if (firstSwatch) colorOptionIndex = parseInt(firstSwatch.getAttribute('data-option-index'));
  }

  if (variants[0] && variants[0].options) {
    variants[0].options.forEach(function(val, i) { currentOptions[i] = val; });
  }

  // IMAGE FILTERING BY ALT TEXT
  function filterImagesByColor(colorName) {
    var thumbs = document.querySelectorAll('.gallery-thumb');
    var mainImg = document.getElementById('mainImage');
    var colorLower = colorName.toLowerCase();
    var matched = [];

    thumbs.forEach(function(thumb) {
      var alt = (thumb.getAttribute('data-alt') || '').toLowerCase();
      if (alt.indexOf(colorLower) !== -1) {
        matched.push(thumb);
        thumb.style.display = '';
      } else {
        thumb.style.display = 'none';
        thumb.classList.remove('active');
      }
    });

    if (matched.length === 0) {
      thumbs.forEach(function(t) { t.style.display = ''; });
      return;
    }

    thumbs.forEach(function(t) { t.classList.remove('active'); });
    matched[0].classList.add('active');
    if (mainImg) mainImg.src = matched[0].getAttribute('data-full');
  }

  // Preload all product images for instant switching
  document.querySelectorAll('.gallery-thumb').forEach(function(thumb) {
    var preload = new Image();
    preload.src = thumb.getAttribute('data-full');
  });

  var selectedSwatch = document.querySelector('.color-swatches .selected');
  if (selectedSwatch) filterImagesByColor(selectedSwatch.getAttribute('data-value'));

  window.selectOption = function(btn) {
    var optionIndex = parseInt(btn.getAttribute('data-option-index'));
    var value = btn.getAttribute('data-value');
    currentOptions[optionIndex] = value;

    btn.parentElement.querySelectorAll('button').forEach(function(s) { s.classList.remove('selected'); });
    btn.classList.add('selected');

    var label = document.getElementById('selectedOption' + (optionIndex + 1));
    if (label) label.textContent = value;

    var matched = findVariant();
    if (matched) {
      document.getElementById('variantId').value = matched.id;
      updatePrice(matched);
      var addBtn = document.querySelector('.add-to-cart-btn');
      if (addBtn) {
        addBtn.disabled = !matched.available;
        addBtn.textContent = matched.available ? 'Add to cart' : 'Sold out';
      }
    }

    if (optionIndex === colorOptionIndex) filterImagesByColor(value);
  };

  function findVariant() {
    for (var i = 0; i < variants.length; i++) {
      var match = true;
      for (var key in currentOptions) {
        if (variants[i].options[parseInt(key)] !== currentOptions[key]) { match = false; break; }
      }
      if (match) return variants[i];
    }
    return null;
  }

  function updatePrice(v) {
    var pe = document.querySelector('.price-current');
    var we = document.querySelector('.price-was');
    var be = document.querySelector('.product-discount-badge');
    if (pe) pe.textContent = formatMoney(v.price);
    if (v.compare_at_price && v.compare_at_price > v.price) {
      if (we) { we.textContent = formatMoney(v.compare_at_price); we.style.display = ''; }
      if (be) { be.textContent = Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100) + '% off'; be.style.display = ''; }
    } else {
      if (we) we.style.display = 'none';
      if (be) be.style.display = 'none';
    }
  }

  function formatMoney(cents) {
    var sym = window.shopCurrency || '$';
    return sym + (cents / 100).toFixed(2);
  }

  window.changeMainImage = function(btn) {
    document.getElementById('mainImage').src = btn.getAttribute('data-full');
    document.querySelectorAll('.gallery-thumb').forEach(function(t) { t.classList.remove('active'); });
    btn.classList.add('active');
  };

  window.changeQty = function(delta) {
    var inp = document.getElementById('qtyInput');
    if (inp) inp.value = Math.max(1, Math.min(99, (parseInt(inp.value) || 1) + delta));
  };

  // ADULT/KIDS SWITCH VIA TAGS
  var pairedHandle = document.body.getAttribute('data-paired-handle');
  if (pairedHandle) {
    var isKids = document.body.getAttribute('data-is-kids') === 'true';

    fetch('/products/' + pairedHandle + '.js')
      .then(function(r) { if (!r.ok) throw 'nope'; return r.json(); })
      .then(function(d) {
        if (!d || !d.handle) return;
        var ph = document.getElementById('fitTogglePlaceholder');
        if (!ph) return;
        var pairedUrl = '/products/' + d.handle;
        var currentUrl = window.location.pathname;
        ph.innerHTML = '<div class="product-option"><label class="option-label">Fit</label><div class="option-values fit-toggle">' +
          (isKids
            ? '<a href="' + pairedUrl + '" class="fit-btn">Adult</a><span class="fit-btn selected">Kids</span>'
            : '<span class="fit-btn selected">Adult</span><a href="' + pairedUrl + '" class="fit-btn">Kids</a>') +
          '</div></div>';
      })
      .catch(function() {});
  }

  // MOVE SIZE TABLES TO DIMENSIONS
  var dc = document.getElementById('productDetailsContent');
  var dm = document.getElementById('dimensionsContent');
  if (dc && dm) {
    dc.querySelectorAll('table').forEach(function(t) {
      dm.appendChild(t.cloneNode(true));
      t.remove();
    });
  }
})();
